import React, { useContext } from 'react';

import CartEventsContext from '../../../common/contexts/CartEventsContext';
import LocResourcesContext from '../../../common/contexts/LocResourcesContext';
import { RewardShopArticle } from '../../../common/utils/types';
import AddToCartComponent from '../AddToCart';

interface ArticleHighlightedProps {
  article: RewardShopArticle;
  view: string;
}

const ArticleHighlighted = ({ article, view }: ArticleHighlightedProps) => {
  const GLOBAL_PREFIX = 'loy-bp-rws-articles-highlighted__item';
  const { isLogged, redeemableBalance, isPromotionalArticle } = useContext(CartEventsContext);
  const { onFormatLocale } = useContext(LocResourcesContext);

  const hasBalance = () => {
    return (redeemableBalance ?? 0) >= (article.currentPoints ?? 0);
  };

  const prefix = isLogged ? '/account/bonus' : '/bonus';
  const path = `${article.productGroups[0].path.replace('/shop', prefix)}/${article.shopIdentifier}`;

  const promotionalPercentage = (article: RewardShopArticle) => {
    if (!article.originalPoints || !article.promotionalPrice) return 0;
    return Math.floor(
      ((article.originalPoints - article.promotionalPrice) * 100) / article.originalPoints,
    );
  };

  const renderInfoPoints = (article: RewardShopArticle, hasBalance: boolean) => {
    if (isPromotionalArticle?.(article)) {
      return [
        <span className={`${GLOBAL_PREFIX}_info_points ${GLOBAL_PREFIX}_info_points--old-price`}>
          {article.originalPoints}
        </span>,
        <span
          className={`${GLOBAL_PREFIX}_info_points ${GLOBAL_PREFIX}_info_points--balance--promotion`}>
          {article.currentPoints} {onFormatLocale?.('bp.points')}
        </span>,
      ];
    } else {
      return (
        <div
          className={`${GLOBAL_PREFIX}_info_points 
                ${GLOBAL_PREFIX}_info_points--balance`}>
          {article.currentPoints} {onFormatLocale?.('bp.points')}
        </div>
      );
    }
  };

  return (
    <li id={`highlighted-${article.shopIdentifier}.0`} className={`${GLOBAL_PREFIX}`}>
      <div className={`${GLOBAL_PREFIX}__img`}>
        <a href={path} title={article.name}>
          <img src={article.picture} alt={article.name} title={article.name} />
          {article.isNew === true ? (
            <div className={`${GLOBAL_PREFIX}__new_flag`}>
              {onFormatLocale?.('product.article.badge.new')}
            </div>
          ) : (
            ''
          )}
          {isPromotionalArticle?.(article) ? (
            <div className={`${GLOBAL_PREFIX}__promotion`}>- {promotionalPercentage(article)}%</div>
          ) : (
            ''
          )}
        </a>
      </div>
      <div className={`${GLOBAL_PREFIX}_info`}>
        <div className={`${GLOBAL_PREFIX}_info_link`}>
          <a href={path} title={article.name}>
            {article.name}
          </a>
        </div>
        {renderInfoPoints(article, hasBalance())}
        {!!redeemableBalance &&
          redeemableBalance !== -1 &&
          hasBalance() &&
          article.currentPoints && (
            <div className={`${GLOBAL_PREFIX}_info_points`}>
              <AddToCartComponent
                articleId={article.articleId}
                articleShopId={article.shopIdentifier}
                articleSelection={article.selection}
                max={redeemableBalance / article.currentPoints}
                quantityInCart={article?.quantityInCart ?? 0}
              />
            </div>
          )}
        {view === 'private' && !hasBalance() && (
          <div className={`${GLOBAL_PREFIX}_info_no_points`}>
            {onFormatLocale?.('mzp.bonuspoints.savemore')}
          </div>
        )}
      </div>
    </li>
  );
};

export default ArticleHighlighted;
